import axios from 'axios';

export const loadAllForms = async () => {
    const { data: { forms } } = await axios.get('/app/smartFormFunnel/forms/all');

    return forms;
};
